import { DropdownOptionModel } from '@Common/Forms/models/dropdown-option.model';
import { TargetingAddToTypeEnum } from '../enums/targeting-add-to-type.enum';

export const targetingAddToOptions: DropdownOptionModel[] = [
    new DropdownOptionModel(`Targeting.add.to.${TargetingAddToTypeEnum.LIST}`, TargetingAddToTypeEnum.LIST),
    new DropdownOptionModel(`Targeting.add.to.${TargetingAddToTypeEnum.DISTRIBUTION}`, TargetingAddToTypeEnum.DISTRIBUTION),
];
